import Dialog from "@material-ui/core/Dialog";
import {Box, Button, FormControl, Grid, InputAdornment, InputLabel, Select, TextField} from "@material-ui/core";
import * as React from "react";
import Typography from "@material-ui/core/Typography";
import closeIcon from "../../assets/images/closeVector.svg";
import groupIcon from "../../assets/images/group.svg";
import calendar from "../../assets/images/calendar.svg";
import {useEffect, useState} from "react";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {TransactionsService} from "../TransactionsList/TransactionsService";
import {CashGroupService} from "../../pages/CashGroups/CashGroupService";
import {
    convertCurrencyFormat,
    convertCurrencyFormatPositiveNegative,
    convertToBirthDate
} from "../../utils/numberConvertor";
import moment from "jalali-moment";
import emptyList from "../../assets/lottie/empty-list_1.json";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {css} from "@emotion/css";
import {Player} from "@lottiefiles/react-lottie-player";

const RegisterNewDeposit = ({openDialog, handleClose, needRefresh}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new TransactionsService(fundID, token, snackbar, loading)
    const groupService = new CashGroupService(fundID, token, snackbar, loading)

    const [groupList, setGroupList] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState(-1);
    const [date, setDate] = useState("");
    const [memberAccountsList, setMemberAccountsList] = useState([]);

    const [sum, setSum] = useState("");

    useEffect(() => {
        if (typeof groupService !== 'undefined') {
            groupService.getCashGroupsList(fundID, 0, "", "", 100)
                .then(response => {
                    setGroupList(response.data)
                    if (response.data && response.data.length > 0) {
                        setSelectedGroupId(response.data[0].id)
                    }
                }).catch(reason => {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت اطلاعات گروه ها!"))
            })
        }
    }, [])

    useEffect(() => {
        if (openDialog) {
            setSum("")
            setMemberAccountsList([])
            if (groupList && groupList.length > 0) {
                setSelectedGroupId(groupList[0].id)
            } else
                setSelectedGroupId(-1)
            setDate("")
        }
    }, [openDialog]);


    function loadAccountsList() {
        if (date.length === 10) {
            loading(setLoadingStateDispatch(true))
            service.getGroupAccounts(fundID, selectedGroupId)
                .then(response => {
                        setMemberAccountsList(response)
                        loading(setLoadingStateDispatch(false))
                    }
                ).catch(reason => {
                ServerErrorHandler(reason,"خطا در بارگزاری اطلاعات حساب ها!",snackbar,loading)
            })
        } else
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "لطفا تاریخ انجام پرداخت را به درستی وارد نمایید!"))
    }

    function saveTransactions() {
        needRefresh(true)

        const data = []
        memberAccountsList.map((item, index) => {
            const value = document.getElementById(`transactionField${item.id}`).value

            if (value !== "" && value !== "-" && value !== "-0" && value !== "0") {
                data.push({
                    "amount": value.replaceAll(",", ""),
                    "depositAccountId": item.id,
                    "depositedAt": moment.from(date, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
                })
            }
        })

        service.setNewTransactions(fundID, selectedGroupId, data, clearFields)
    }

    function clearFields() {
        setDate("")
        setMemberAccountsList([])
        setSum("")
    }

    const defaultOptionsNotFound = {
        loop: true,
        autoplay: true,
        animationData: emptyList,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    function calculateSumOfTransactions() {

        let sumOfTrnas = 0
        memberAccountsList.map((item, index) => {
            const value = document.getElementById(`transactionField${item.id}`).value

            if (value !== "" && value !== "-") {
                sumOfTrnas = sumOfTrnas + parseFloat(value.replaceAll(",", ""))
            }
        })

        setSum(sumOfTrnas.toString())
    }

    return (
        <Dialog fullScreen onClose={handleClose} aria-labelledby="customized-dialog-title" open={openDialog}
                id="customized-full-screen-dialog">
            <section className="pageContainerFull">
                <Box className="transactionHeader">
                    <section className="transactionTitle">
                        <Typography variant={"h6"}>
                            تراکنشات واریز پس انداز
                        </Typography>

                        <img onClick={handleClose} className="cursorPointer" src={closeIcon} alt=""/>
                    </section>
                    <span className="mb-3">لطفا گروه و تاریخ واریز را مشخص نمایید!</span>
                    <Box style={{display: "flex", flexWrap: "wrap"}}>
                        <Grid sm={6} md={12} lg={8} xl={8} className='p-2 w-100'>
                            <FormControl
                                className="w-100"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img src={groupIcon} alt=""/>
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined" label="گروه"
                                placeholder="...">
                                <InputLabel htmlFor="filled-age-native-simple">گروه</InputLabel>
                                <Select label="گروه"
                                        value={selectedGroupId}
                                        onChange={e => {
                                            setSelectedGroupId(e.target.value)
                                        }}>
                                    {groupList.map((item, index) => {
                                        return <option value={item.id}>{item.name}</option>

                                    })}
                                </Select>

                            </FormControl>
                        </Grid>
                        <Grid sm={12} md={12} lg={2} xl={2} className="w-100 p-2">
                            <TextField
                                value={convertToBirthDate(date)}
                                onChange={e => {
                                    setDate(convertToBirthDate(e.target.value))
                                }}
                                className='w-100'
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img src={calendar} alt=""/>
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined" label="تاریخ"/>
                        </Grid>
                        <Grid sm={12} md={12} lg={2} xl={2} className="w-100 p-2 d-flex flex-grow-1 ">
                            <Button className="w-100" onClick={loadAccountsList}>بارگزاری حساب های گروه</Button>
                        </Grid>
                    </Box>
                </Box>
                <Box className="d-flex flex-column" style={{padding: "0.5rem 3rem", overflowY: "auto"}}>
                    {
                        memberAccountsList.length > 0 ?
                            memberAccountsList.map((item, index) => {
                                return <Box className="cardCustom">
                                    <Grid xs={6} sm={4} md={4} lg={1} xl={1} className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">#</span>
                                        <span className="cardCustomDescription">{index + 1}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={4} lg={2} xl={2} className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">نام و نام خانوادگی</span>
                                        <span
                                            className="cardCustomDescription">{`${item.ownerFirstName} ${item.ownerLastName}`}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={4} lg={1} xl={1} className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">کد ملی</span>
                                        <span className="cardCustomDescription">{item.ownerNationalCode}</span>
                                    </Grid>
                                    <Grid xs={6} sm={4} md={4} lg={2} xl={2} className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">موجودی(ریال)</span>
                                        <span className={`cardCustomDescription ${css`direction: ltr;`}`}>{convertCurrencyFormatPositiveNegative(item.currentBalance)}</span>
                                    </Grid>
                                    <Grid xs={6} sm={3} md={3} lg={1} xl={1} className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">کد پس انداز</span>
                                        <span className="cardCustomDescription">{item.number}</span>
                                    </Grid>

                                    <Grid xs={6} sm={3} md={3} lg={2} xl={2} className="cardCustomContent p-2 w-100">
                                        <span className="cardCustomTitle">تاریخ واریز</span>
                                        <span className="cardCustomDescription">{date}</span>
                                    </Grid>
                                    <Grid xs={12} sm={4} md={4} lg={3} xl={3} className="cardCustomContent p-2 w-100">
                                        <TextField id={`transactionField${item.id}`}
                                                   dir="ltr"
                                                   className='w-100'
                                                   variant="outlined"
                                                   onChange={e => {
                                                       const amount = e.target.value.replaceAll(",", "")
                                                       e.target.value = amount === "" ? "" : convertCurrencyFormatPositiveNegative(amount)
                                                       calculateSumOfTransactions()
                                                   }}
                                                   label="مبلغ(ریال)"/>
                                    </Grid>
                                </Box>
                            }) :
                            <div className='w-100 h-100' style={{display: 'grid', placeItems: 'center'}}>
                                {loading.loading ?
                                    "" :
                                    <section className='d-flex flex-column'
                                             style={{justifyContent: 'center', alignItems: 'center'}}>
                                        <Player
                                            style={{width:'100%'}}
                                            loop
                                            autoplay
                                            className="player"
                                            src={emptyList}
                                        />
                                        <Typography className='mt-1 py-3' style={{marginTop: '1rem'}} variant='inherit'>
                                            هیچ اطلاعاتی یافت نشد !
                                        </Typography>
                                    </section>
                                }
                            </div>
                    }


                    {memberAccountsList.length > 0 ?
                        <Grid sm={12} md={12} lg={12} xl={12}
                              className="w-100 p-2 d-flex flex-grow-1 justifyContentEnd">
                            <section className="cardCustomSum">
                                <span className="cardCustomTitle px-2">مجموع : </span>
                                <span className={css`direction: ltr;`}>{convertCurrencyFormatPositiveNegative(sum)}</span>
                                <span className="px-2 fs-1 font_primary_regular">ریال</span>
                            </section>
                            <Button onClick={saveTransactions}>ذخیره</Button>
                        </Grid> : ""
                    }

                </Box>

            </section>

        </Dialog>

    )
}
export default RegisterNewDeposit